/** Interprète un montant saisi (virgule ou point, espaces insécables). */
export function parseAmount(value) {
  if (typeof value === 'number') return value
  if (value == null) return NaN
  const normalized = String(value)
    .trim()
    .replace(/[\s\u00a0\u202f]/g, '')
    .replace(',', '.')
  if (normalized === '' || normalized === '-' || normalized === '.') return NaN
  return parseFloat(normalized)
}
